import { type ProductBySlugResponse } from '@/modules/product/aliases';
import {
  type ProductMediaAssetFormat,
  type ProductPicture,
  type ProductVideo,
} from '@/modules/product/types';

export function toProductPicture(
  picture: ProductBySlugResponse['pictures'][number]
): ProductPicture {
  return {
    id: picture.id ?? 0,
    original_width: picture.original_width,
    original_height: picture.original_height,
    is_square: picture.is_square ?? false,
    formats: picture.formats as ProductMediaAssetFormat,
  };
}

export function toProductVideo(
  video: NonNullable<ProductBySlugResponse['videos']>[number]
): ProductVideo {
  return {
    id: video.id,
    video_url: video.video_url,
    thumbnail: {
      formats: (video.thumbnail.formats ?? {}) as ProductMediaAssetFormat,
    },
    outputs: video.outputs.map((output) => ({
      format: output.format ?? '',
      url: output.url ?? '',
    })),
  };
}

export function hasThumbnailFormats(video: ProductVideo): boolean {
  return Object.keys(video.thumbnail.formats).length > 0;
}
